export const instagramlink = "https://www.instagram.com/mariaadvisory/";

export const fbpagelink = "https://www.facebook.com/mariaadvisory/";

export const fbeventlink = "https://www.facebook.com/SunwaveServices/";

export const linkedinlink = "https://www.linkedin.com/in/pooleymaria/";
